function addReviewSnippets() {
    const reviews = $('.review');
    let sum = 0;
    let data = {
        '@context': 'http://schema.org',
        '@type': 'LocalBusiness',
        'name': window.WPURLS.sitetitle,
        'image': $('.header__logo img').attr('src'),
        'review': [],
    };

    $(reviews).each(function(index, item) {
        data.review.push({
            '@type': 'Review',
            'author': $(item).data('author'),
            'datePublished': $(item).data('date'),
            'reviewBody': $(item).data('body'),
            'reviewRating': {
                '@type': 'Rating',
                'bestRating': '5',
                'ratingValue': $(item).data('rating'),
                'worstRating': '1',
            },
        });

        sum += parseFloat($(item).data('rating'));
    });

    data['aggregateRating'] = {
        '@type': 'AggregateRating',
        'ratingValue': (sum / $(reviews).length).toFixed(2),
        'ratingCount': $(reviews).length,
    };

    var el = document.createElement('script');
    el.type = 'application/ld+json';
    el.text = JSON.stringify(data);

    document.querySelector('head').appendChild(el);
}

export default {
    init() {
        addReviewSnippets();
    },

    finalize() {
        
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/reviews.js